const simpleTabs = $tabGroupEl => {

  const tabs = $tabGroupEl.find('.modal__tab-selector');
  const tabContents = $tabGroupEl.find('.modal__tab-content');

  tabs.each((i, tab) => {
    $(tab).on('click', e => {

      tabs.toggleClass('is-active', false);
      tabContents.toggleClass('is-active', false);

      const tabFor = $(e.currentTarget).data('for');

      $tabGroupEl.find(`[data-for="${tabFor}"]`).toggleClass('is-active', true);

    });
  });

};

export default simpleTabs;
